import { useContext } from 'react';
import CardTwo from '../Cards/CardTwo/CardTwo';
import './Rent.scss';
import { CurrentLangContext, LangContext } from '../../contexts/contexts';

function Rent() {
  const langs = useContext(LangContext);
  const rentLangs = langs.rent;

  const CurrentLangC = useContext(CurrentLangContext);
  const currentLang = CurrentLangC[0];
  
  return (
    <section id="rent" className="Rent">
      <h1 className="Rent_title">{rentLangs.title[currentLang]}</h1>
      <div className="Rent_container">
        <div className="rent_content">
          <div className="rent_immo">
            <CardTwo />
            <CardTwo />
            <CardTwo />
            <CardTwo />
            <CardTwo />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Rent;